var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKorpus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4h17v33H11v-2h11V6H9v6H7V4Zm27 11h-8v-2h5v-2h-5V9h7v4h3v24H26v-2h8V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9h-2v5h2V9Zm3 0h2v5h-2V9Zm2 9h-2v5h2v-5Zm-2 9h2v5h-2v-5Zm14-10h-2v5h2v-5Zm-2 9h2v5h-2v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14a1.95 1.95 0 0 0-1.833 1.287L2.395 25.706a5.489 5.489 0 0 0 2.617 6.732A4.941 4.941 0 0 0 7 32.99V37h2v-4.01a4.941 4.941 0 0 0 1.99-.553 5.489 5.489 0 0 0 2.616-6.732L9.834 15.287A1.95 1.95 0 0 0 8 14ZM4.276 26.388 8 16.097l3.725 10.29a3.489 3.489 0 0 1-1.663 4.278c-.42.22-.889.335-1.364.335H7.303c-.475 0-.943-.114-1.364-.335a3.489 3.489 0 0 1-1.663-4.278Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorpus);
export default __webpack_public_path__ + "static/media/korpus.9c5587ff963eceafce13a8f92edc9627.svg";
export { ForwardRef as ReactComponent };